/* Quikflip — Hero Hoodie Classic landing page interactions */
(function () {
  'use strict';

  /* ---- Hero video: ensure autoplay + sound toggle (event delegation) ---- */
  function initHeroVideo(scope) {
    var player = (scope || document).querySelector('.qf-lp .hero__player');
    if (!player) return;
    var video = player.querySelector('.hero__video');
    if (video) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  document.addEventListener('click', function (e) {
    var soundBtn = e.target.closest && e.target.closest('.qf-lp .hero__sound');
    if (!soundBtn) return;
    var player = soundBtn.closest('.hero__player');
    var video = player && player.querySelector('.hero__video');
    if (!video) return;
    video.muted = !video.muted;
    player.classList.toggle('is-unmuted', !video.muted);
    soundBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    if (!video.muted) {
      var pp = video.play();
      if (pp && pp.catch) pp.catch(function () {});
    }
  });

  /* ---- FAQ accordion (event delegation) ---- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.qf-lp .acc__q');
    if (!q) return;
    var item = q.closest('.acc__item');
    var list = q.closest('.acc');
    var isOpen = item.classList.contains('is-open');
    if (list) {
      list.querySelectorAll('.acc__item').forEach(function (i) { i.classList.remove('is-open'); });
    }
    if (!isOpen) item.classList.add('is-open');
  });

  /* ---- Sticky mobile CTA: reveal once the hero scrolls out of view ---- */
  var stickyObserver = null;
  function initSticky() {
    var sticky = document.querySelector('.qf-lp.stickybar');
    var hero = document.querySelector('.qf-lp.hero');
    if (!sticky || !hero) return;
    if (stickyObserver) stickyObserver.disconnect();
    stickyObserver = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    stickyObserver.observe(hero);
  }

  /* ---- Sticky / closer CTAs that should scroll to the buy section ---- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-qf-scroll-to-buy]');
    if (!link) return;
    var target = document.querySelector('.qf-lp-buy-anchor') ||
                 document.querySelector('.featured-product') ||
                 document.querySelector('[id*="featured_product"], [id*="featured-product"]');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ---- Links that should scroll to the reviews section ---- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-qf-scroll-to-reviews]');
    if (!link) return;
    var target = document.getElementById('qf-lp-reviews') ||
                 document.querySelector('.qf-lp.reviews');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  function init() {
    initHeroVideo(document);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    initHeroVideo(e.target);
    initSticky();
  });
})();

/* ============================================================
   LP Weather Arc (qf-lp-weather.liquid) — scroll-scrubbed day
   ============================================================ */
(function () {
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function mixHex(h1, h2, t) {
    function rgb(h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }
    var a = rgb(h1), b = rgb(h2);
    return 'rgb(' + Math.round(lerp(a[0], b[0], t)) + ',' + Math.round(lerp(a[1], b[1], t)) + ',' + Math.round(lerp(a[2], b[2], t)) + ')';
  }
  function fmtTime(mins) {
    var h = Math.floor(mins / 60), m = Math.round(mins % 60);
    if (m === 60) { m = 0; h += 1; }
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + ':' + (m < 10 ? '0' + m : m) + ' ' + ap;
  }

  function initWeather(wx) {
    if (!wx || wx._qfwInit) return;
    wx._qfwInit = true;

    var elTemp = wx.querySelector('[data-qfw-temp]');
    var elTime = wx.querySelector('[data-qfw-time]');
    var elTag = wx.querySelector('[data-qfw-tag]');
    var elState = wx.querySelector('[data-qfw-state]');
    var elHint = wx.querySelector('[data-qfw-hint]');
    var elFlip = wx.querySelector('[data-qfw-flip]');
    var elFill = wx.querySelector('[data-qfw-fill]');
    var elDot = wx.querySelector('[data-qfw-dot]');
    var skyNoon = wx.querySelector('.qfw__sky--noon');
    var skyDusk = wx.querySelector('.qfw__sky--dusk');
    var sun = wx.querySelector('.qfw__sun');
    var haze = wx.querySelector('.qfw__haze');

    var shots = Array.prototype.slice.call(wx.querySelectorAll('[data-qfw-shot]'));
    if (!shots.length) return;

    var stages = shots.map(function (el) {
      return {
        el: el,
        until: parseFloat(el.getAttribute('data-until')) || 1.01,
        tag: el.getAttribute('data-tag') || '',
        state: el.getAttribute('data-state') || '',
        flip: el.getAttribute('data-flip') === '1'
      };
    });

    var tempStart = parseFloat(wx.getAttribute('data-temp-start'));
    var tempPeak = parseFloat(wx.getAttribute('data-temp-peak'));
    var tempEnd = parseFloat(wx.getAttribute('data-temp-end'));
    var minStart = parseFloat(wx.getAttribute('data-min-start'));
    var minEnd = parseFloat(wx.getAttribute('data-min-end'));
    if (isNaN(tempStart)) tempStart = 58;
    if (isNaN(tempPeak)) tempPeak = 88;
    if (isNaN(tempEnd)) tempEnd = 64;
    if (isNaN(minStart)) minStart = 420;
    if (isNaN(minEnd)) minEnd = 1200;

    function tempAt(p) {
      if (p <= 0.30) return lerp(tempStart, tempPeak, p / 0.30);
      if (p <= 0.60) return tempPeak;
      return lerp(tempPeak, tempEnd, (p - 0.60) / 0.40);
    }

    var lastIdx = -1, lastTag = '', lastState = '', raf = 0;

    function render() {
      raf = 0;
      var vh = window.innerHeight;
      var total = wx.offsetHeight - vh;
      var p = clamp01(total > 0 ? -wx.getBoundingClientRect().top / total : 0);
      wx.style.setProperty('--p', p.toFixed(4));

      if (skyNoon) skyNoon.style.opacity = clamp01((p - 0.12) / 0.22);
      if (skyDusk) skyDusk.style.opacity = clamp01((p - 0.62) / 0.26);

      var b = Math.sin(Math.PI * p);
      if (sun) {
        sun.style.left = (18 + 64 * p) + '%';
        sun.style.top = (82 - 70 * b) + '%';
        sun.style.transform = 'translate(-50%,-50%) scale(' + (1 + (1 - b) * 0.16).toFixed(3) + ')';
        var core = mixHex('#ff7a2e', '#fff7da', b);
        var edge = mixHex('#ff5e1e', '#ffe49c', b);
        sun.style.background = 'radial-gradient(circle at 50% 50%,' + core + ' 0%,' + edge + ' 40%,transparent 72%)';
        sun.style.boxShadow = '0 0 120px 44px rgba(255,' + Math.round(lerp(120, 240, b)) + ',' + Math.round(lerp(60, 190, b)) + ',' + (0.4 + 0.45 * b).toFixed(2) + ')';
      }
      if (haze) haze.style.opacity = (b * 0.5).toFixed(3);

      if (elTemp) elTemp.textContent = Math.round(tempAt(p));
      if (elTime) elTime.textContent = fmtTime(lerp(minStart, minEnd, p));
      if (elFill) elFill.style.width = (p * 100) + '%';
      if (elDot) elDot.style.left = (p * 100) + '%';

      var idx = stages.length - 1;
      for (var i = 0; i < stages.length; i++) { if (p < stages[i].until) { idx = i; break; } }
      var st = stages[idx];
      if (idx !== lastIdx) {
        for (var j = 0; j < stages.length; j++) { stages[j].el.classList.toggle('is-on', j === idx); }
        lastIdx = idx;
      }
      if (elTag && st.tag !== lastTag) { elTag.textContent = st.tag; lastTag = st.tag; }
      if (elState && st.state !== lastState) { elState.textContent = st.state; lastState = st.state; }
      if (elFlip) elFlip.classList.toggle('is-on', st.flip);
      if (elHint) elHint.style.opacity = p > 0.04 ? '0' : '1';
    }

    function onScroll() { if (!raf) raf = requestAnimationFrame(render); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    render();
  }

  function initAllWeather(root) {
    (root || document).querySelectorAll('.qfw').forEach(initWeather);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllWeather(); });
  } else {
    initAllWeather();
  }
  document.addEventListener('shopify:section:load', function (e) { initAllWeather(e.target); });
})();

/* ============================================================
   LP header cart count — keep the brand-bar bubble in sync with
   the live cart (Rebuy Smart Cart manages its own state).
   ============================================================ */
(function () {
  var els = document.querySelectorAll('[data-qf-cart-count]');
  if (!els.length) return;

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        document.querySelectorAll('[data-qf-cart-count]').forEach(function (el) {
          el.textContent = n;
          el.classList.toggle('is-empty', n === 0);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  // Rebuy + theme cart events (cover common names; harmless if unused)
  ['rebuy:cart.change', 'rebuy:smartcart.show', 'rebuy:cart.ready',
   'cart:updated', 'cart:refresh', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });

  // Fallback: re-sync when the tab regains focus (e.g. after a Rebuy add)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
})();
